import _implicitStylesheets from "./notification.css";
import _implicitScopedStylesheets from "./notification.scoped.css?scoped=true";
import _appxMessageBox from "appx/messageBox";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, c: api_custom_element, i: api_iterator} = $api;
  return $cmp.hasNotifications ? api_iterator($cmp.notifications, function (item) {
    return api_custom_element("appx-message-box", _appxMessageBox, {
      props: {
        "type": item.notification.type,
        "variant": "notification",
        "message": item.notification.message,
        "action": item.notification.action,
        "closeCallback": $cmp.handleClose,
        "indexClose": item.notification.id
      },
      key: api_key(0, item.index)
    });
  }) : stc0;
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7kho0sj9udb";
tmpl.legacyStylesheetToken = "appx-notification_notification";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
